import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { useQuery } from "@apollo/client";
import { AGREEMENTS } from "component/Setting/graphql/query";

const PrivacyPolicy = () => {
  const { loading, data } = useQuery(AGREEMENTS, {
    variables: {
      typeOf: "privacy-policy",
    },
  });

  return (
    <Container>
      <Box sx={{ my: 10, px: { xs: 5, md: 0 } }}>
        <Typography variant="h2" sx={{ mb: 2 }}>
          Privacy Policy
        </Typography>
        {!loading && data ? (
          <>
            <Typography
              variant="body1"
              dangerouslySetInnerHTML={{
                __html: data?.agreements?.edges[0]?.node?.data,
              }}
            />
          </>
        ) : null}
      </Box>
    </Container>
  );
};

export default PrivacyPolicy;
